export const home = "الرئيسية";
export const forum = "المنتدى";
export const groups = "المجموعات";
export const messages = "الرسائل";
export const profile = "الملف الشخصي";
export const settings = "الإعدادات";
export const creators = "المبدعون";
export const dramas = "المسلسلات";
export const search = "البحث";
export const login = "تسجيل الدخول";
export const signup = "إنشاء حساب";
export const logout = "تسجيل الخروج";
export const edit = "تعديل";
export const delete_action = "حذف";
export const save = "حفظ";
export const cancel = "إلغاء";
export const submit = "إرسال";
export const loading = "جار التحميل...";
export const error = "خطأ";
export const success = "نجح";
export const warning = "تحذير";
export const info = "معلومات";
export const confirm = "تأكيد";
export const yes = "نعم";
export const no = "لا";
export const back = "العودة";
export const next = "التالي";
export const previous = "السابق";
export const close = "إغلاق";
export const open = "فتح";
export const view = "عرض";
export const hide = "إخفاء";
export const show = "إظهار";
export const select = "اختيار";
export const clear = "مسح";
export const reset = "إعادة تعيين";
export const refresh = "تحديث";
export const update = "تحديث";
export const create = "إنشاء";
export const add = "إضافة";
export const remove = "إزالة";
export const share = "مشاركة";
export const copy = "نسخ";
export const paste = "لصق";
export const cut = "قص";
export const undo = "تراجع";
export const redo = "إعادة";
export const upload = "رفع";
export const download = "تحميل";
export const print = "طباعة";
export const email = "البريد الإلكتروني";
export const password = "كلمة المرور";
export const username = "اسم المستخدم";
export const name = "الاسم";
export const title = "العنوان";
export const description = "الوصف";
export const content = "المحتوى";
export const category = "الفئة";
export const tag = "علامة";
export const tags = "العلامات";
export const date = "التاريخ";
export const time = "الوقت";
export const author = "الكاتب";
export const post = "منشور";
export const posts = "منشورات";
export const comment = "تعليق";
export const comments = "التعليقات";
export const like = "إعجاب";
export const likes = "الإعجابات";
export const dislike = "عدم إعجاب";
export const vote = "تصويت";
export const votes = "الأصوات";
export const reply = "رد";
export const replies = "الردود";
export const follow = "متابعة";
export const following = "متابَع";
export const followers = "المتابعون";
export const member = "عضو";
export const members = "الأعضاء";
export const online = "متصل";
export const offline = "غير متصل";
export const active = "نشط";
export const inactive = "غير نشط";
export const public_text = "عام";
export const private_text = "خاص";
export const featured = "مميز";
export const popular = "شائع";
export const trending = "رائج";
export const latest = "الأحدث";
export const oldest = "الأقدم";
export const top = "الأعلى";
export const new_text = "جديد";
export const hot = "ساخن";
export const all = "الكل";
export const none = "لا شيء";
export const other = "أخرى";
export const more = "المزيد";
export const less = "أقل";
export const page = "صفحة";
export const pages = "الصفحات";
export const item = "عنصر";
export const items = "العناصر";
export const result = "نتيجة";
export const results = "النتائج";
export const found = "موجود";
export const not_found = "غير موجود";
export const empty = "فارغ";
export const full = "ممتلئ";
export const available = "متاح";
export const unavailable = "غير متاح";
export const enabled = "مفعل";
export const disabled = "معطل";
export const required = "مطلوب";
export const optional = "اختياري";
export const invalid = "غير صحيح";
export const valid = "صحيح";